<template>
  <div>
    <b-modal
        id="modal-edit-todo"
        cancel-variant="outline-secondary"
        centered
        ref="modal-edit-todo"
        title="更改作品"
        no-close-on-backdrop
         scrollable
         hide-footer
      size="sm"
  >

        <b-form v-on:submit.prevent="add_eleave(class_detail.id)">
          <b-row>
              <!-- email -->
              <b-col cols="12">
                <b-form-group label="作品" label-for="content">
                  <b-form-input id="content" v-model="edit_todo_content" size="sm" />
                </b-form-group>
              </b-col>
              <!-- submit and reset -->
              <b-col cols="12" class="mt-1">
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mb-1" @click="update()" block>
                  確定
                </b-button>
              </b-col>
            </b-row>



        </b-form>
      </b-modal>


    <b-modal
        id="model-change-student"
        cancel-variant="outline-secondary"
        centered
        ref="model-change-student"
        title="轉學生"
        no-close-on-backdrop
         scrollable
         hide-footer
      size="sm"
  >

        <b-form>
          <b-row>
              <!-- email -->

              <b-col cols="12">
                <b-form-group label="學生編碼" label-for="lesson">
                  <b-form-input id="lesson" v-model="change_student" size="sm" />
                </b-form-group>
              </b-col>
              <!-- submit and reset -->
              <b-col cols="12" class="mt-1">
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mb-1" @click="call_change_student()" block>
                  確定
                </b-button>
              </b-col>
            </b-row>



        </b-form>
      </b-modal>

        <Purchase-add-new
      :is-add-new-purchase-sidebar-active.sync="isAddNewPurchaseSidebarActive"
      @clicked="one"
    />

    <b-card>
    <b-row>
      <b-col
        cols="12"
        md="9"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <b-form-group>
          <v-select
            v-model="perPage"
            label="Number of rows"
            :options="pageOptions"
            :clearable="false"
          />
        </b-form-group>
      </b-col>

      <b-col
        cols="12"
        md="3"
      >
        <div class="d-flex align-items-center justify-content-end">
          <b-form-input
            v-model="searchString"
            class="d-inline-block"
            placeholder="Search..."
          />
        </div>
      </b-col>
    </b-row>
    <!-- table -->
    <b-table
      ref="selectableTable"
      :select-mode="selectMode"
      :items="items"
      :fields="fields"
      responsive
      striped
      class="mb-0"
      @row-selected="onRowSelected"
    >
    <template #cell(action)="data">
      <b-button size="sm" variant="outline-primary"  @click="change_enrollment(data.item.id)">
        轉堂
      </b-button>
      <!-- <b-button class="ml-1" size="sm" variant="outline-danger" @click="change_student_now(data.item.id)">
        轉學生
      </b-button> -->
     
      <b-button class="ml-1" size="sm" variant="outline-warning" v-if="data.item.status != 'LEAVE'" @click="absent(data.item.id)">
        請假
      </b-button>
      <b-button class="ml-1" size="sm" variant="outline-success" v-if="data.item.is_attend != 'Y'" @click="attend(data.item.id)">
        出席
      </b-button>
      <b-button class="ml-3" size="sm" variant="danger" :disabled="data.item.transaction_code != null" @click="delete_enrollment(data.item.id)">
        刪除
      </b-button>
      <b-button class="ml-1" size="sm" variant="danger" @click="terminate(data.item.id)">
        往後終止
      </b-button>
    </template>
      <template #cell(actions)="data">
        <b-dropdown
          variant="link"
          no-caret
          :right="$store.state.appConfig.isRTL"
        >

          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </template>
          <b-dropdown-item :to="{ name: 'apps-Member-view', params: { id: data.item.id } }">
            <feather-icon icon="FileTextIcon" />
            <span class="align-middle ml-50">Details</span>
          </b-dropdown-item>

          <b-dropdown-item :to="{ name: 'apps-Member-edit', params: { id: data.item.id } }">
            <feather-icon icon="EditIcon" />
            <span class="align-middle ml-50">Edit</span>
          </b-dropdown-item>

          <b-dropdown-item>
            <feather-icon icon="TrashIcon" />
            <span class="align-middle ml-50">Delete</span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
      <template #cell(is_attend)="data">
       <span v-if="data.item.is_attend == 'Y'"><feather-icon icon="CheckCircleIcon" color="green" /> </span>
       <span v-if="data.item.is_attend === null && data.item.status == 'LEAVE'"><feather-icon icon="XCircleIcon" color="red" /> </span>
      </template>
    <template #cell(todo_content)="data">
       <b-badge variant="warning" @click="edit_todo(data.item.id,data.item.todo_content)" style="cursor: pointer;">{{ data.item.todo_content }} </b-badge>
      </template>
      <template #cell(center_date_time)="data">
       <b-badge>{{ data.item.center }} </b-badge> <b-badge> {{ data.item.class_date }} </b-badge> <b-badge>{{ data.item.start }}-{{ data.item.end }}</b-badge>
      </template>
      <template #cell(status_number)="data">
        <b-badge :variant="status[1][data.value]">
          {{ status[0][data.value] }}
        </b-badge>
      </template>
    </b-table>
    <b-row>
      <b-col class="mt-1">
        Total : {{ totalRows }} , Display Row {{ startRow }} to {{ endRow }}
      </b-col>
      <b-col>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          align="right"
          size="md"
          class="mt-1"
          @change="handleChangePage"
        />
      </b-col>
    </b-row>
  </b-card>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import PurchaseAddNew from './SidebarNewPurchase.vue'
import vSelect from 'vue-select'
import axios from "axios";
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ref } from '@vue/composition-api'
import {
  BTable, BAvatar, BCardBody, BCard, BBadge, BRow, BCol,BForm, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BInputGroupPrepend, BModal, VBModal
} from 'bootstrap-vue'
import router from '@/router'
export default {
  components: {
    PurchaseAddNew,
    router,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BButton,
    BPagination,
    BCard,
    BCardCode,
    BTable,
    BButton,
    BFormGroup,
    BAvatar,
    BCardBody,
    BBadge,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      deined:JSON.parse(localStorage.getItem('userData')),
      iframe_src : '//cloudfit.pro/invoice.php',
      genderOptions: [
        { label: 'Male', value: 'M' },
        { label: 'Female', value: 'F' },
      ],
      planOptions: [
        { label: 'Basic', value: 'basic' },
        { label: 'Company', value: 'company' },
        { label: 'Enterprise', value: 'enterprise' },
        { label: 'Team', value: 'team' },
      ],
      statusOptions: [
        { label: 'Active', value: 'active' },
        { label: 'Disabled', value: 'disabled' },
      ],
      centerOptions: [],
      transaction_id:null,
      edit_todo_content:null,
      edit_id : null,
      change_student:null,
      transaction:null,
      isAddNewPurchaseSidebarActive: false,
      searchString: null,
      perPage: 10,
      startRow: 1,
      endRow: 10,
      pageOptions: [10, 15, 20],
      totalRows: 1,
      currentPage: 1,
      fields: [{ key: 'id', label: '#' }, { key: 'name', label: 'name' }, { key: 'center_date_time' , label: 'Class'},{ key: 'is_attend', label: '出席' }, { key: 'transaction_code', label: '單據編號' },{key:'action',label: '動作'}],
      /* eslint-disable global-require */
      items: [],
      /* eslint-disable global-require */
      status: [{
        1: 'Active', 2: 'Disabled', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
      },
      {
        1: 'light-success', 2: 'light-danger', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
      selectMode: 'single',
      selected: [],
    }
  },
  watch: {
    currentPage: {
      handler(newValue, oldValue) {
        this.get_data()
      },
    },
    searchString: {
      handler(newValue, oldValue) {
        // console.log("search")
        this.handleSearch()
      },
    },
    perPage: {
      handler(newValue, oldValue) {
        if (newValue < 9) {
          this.perPage = 10
        }
        // console.log("search")
        this.handleSearch()
      },
    },
  },
  created() {
    this.get_data()
  //  this.get_center_data()
  },
  methods: {
    edit_todo(id,exist) {
      this.edit_id = id
      this.edit_todo_content = exist
      this.$refs['modal-edit-todo'].show()
    },
    terminate(enrollment_id) {
      this.$http.post(process.env.VUE_APP_API_BASE+'/enrollment/'+ enrollment_id +'/terminate/', { student_id : router.currentRoute.params.id })
        .then(res => {
          if (res.data.result === true) {
            this.get_data()
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: '更改成功',
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    update() {
      let form = {
        todo_content : this.edit_todo_content,
      }
      this.$refs['modal-edit-todo'].hide()
      this.$http.post(process.env.VUE_APP_API_BASE+'/enrollment/'+this.edit_id+'/update_todo/', form)
        .then(res => {
          if (res.data.result === true) {
            
            this.get_data()
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: '更改成功',
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    absent(booking_id) {
      this.$http.post(process.env.VUE_APP_API_BASE + '/enrollment/' + booking_id + '/absent/')
        .then(res => {
          this.get_data()
        })
    },
    change_enrollment(id) {
      this.$router.push({path : '/class-list/' , query : { enrollment_id : id }} )
    },
    go_to_invoice() {
      this.$router.push('/apps/student/'+ router.currentRoute.params.id+'/class/add/')
    },
    attend(booking_id) {
      this.$http.post(process.env.VUE_APP_API_BASE + '/enrollment/' + booking_id + '/attend/')
        .then(res => {
          this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: '出席成功',
              },
            })
          this.get_data()
        })
    },
    one() {
      this.isAddNewMemberSidebarActive = false
      this.get_data()
    },
    change_student_now(id) {
      this.change_enrollment_id = id
      this.$refs['model-change-student'].show()
    },
    call_change_student() {
      this.$http.post(process.env.VUE_APP_API_BASE + '/enrollment/' + this.change_enrollment_id + '/change_student/', {
        "student_id" : this.change_student
      } ).then(res => {
        if (res.data.result === true) {
            this.$refs['model-change-student'].hide()
            this.get_data()
            //this.get_date_class(this.unformat_date)
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
         }
         
          this.change_student = null
      })
    },
    get_data() {
       this.$http.get(process.env.VUE_APP_API_BASE+`/student/${router.currentRoute.params.id}/enrollments/?perpage=${this.perPage}&page=${this.currentPage}&search=${this.searchString}`)
           .then(res => {
          this.items = res.data.enrollments
          this.totalRows = res.data.total
          this.startRow = res.data.startRow
          this.endRow = res.data.endRow
        })
    },
    delete_enrollment(enrollment_id) {
      this.$bvModal
        .msgBoxConfirm('確定刪除課堂？', {
          title: '刪除課堂',
          size: 'sm',
          okVariant: 'danger',
          okTitle: '確定刪除',
          cancelTitle: '取消',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.$http.post(process.env.VUE_APP_API_BASE+`/enrollment/`+ enrollment_id +`/delete/`,{})
            .then(res => {
              this.get_data()
            })
          }
        })
    },
    get_center_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/centers/')
        .then(res => {
          this.centerOptions = res.data.centers
        })
    },
    handleChangePage() {

    //  this.get_data()
    },
    onRowSelected(items) {
      this.selected = items[0]
      console.log(items)
      if (items[0].is_pdf == 'Y') {
        this.iframe_src = process.env.VUE_APP_API_BASE+'/../../../pdf/INVOICE_'+items[0].code+'.pdf'
        console.log(this.iframe_src)

      } else {
      this.iframe_src = process.env.VUE_APP_API_BASE+'/../../../invoice.php?print=n&code='+items[0].id
      }
      this.transaction_id = items[0].id
      this.$refs['my-modal'].show()
    },
    close() {
      this.iframe_src = process.env.VUE_APP_API_BASE+'/../../../invoice.php'
      this.$refs['my-modal'].hide()
    },
    print() {
      this.iframe_src = process.env.VUE_APP_API_BASE+'/../../../invoice.php?print=y&code='+this.transaction_id
    },
    download() {
      window.location.href = '/../../../pdf/INVOICE_'+this.selected.code+'.pdf'
      //this.iframe_src = '//www.cloudfit.pro/pdf/INVOICE_'+items[0].code+'.pdf'
    },
    async downloadItem() {
      let t = '/pdf/INVOICE_'+this.selected.code+'.pdf'
      const response = await axios.get(t, { responseType: "blob" });
      const blob = new Blob([response.data], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = this.selected.code;
      link.click();
      URL.revokeObjectURL(link.href);
    },
    send() {
      this.$http.post(process.env.VUE_APP_API_BASE+'/transaction/'+this.selected.id+'/send/',{})
        .then(res => {
          this.$refs['my-modal'].hide()
        })
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    selectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.selectRow(2)
    },
    unselectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.unselectRow(2)
    },

    handleSearch() {
      // let _print = `The user searched for: ${searching}\n`
      // this.$refs.pre.appendChild(document.createTextNode(_print))
    // this.searchString = searching
    // this.currentx = 1
    // this.get_data()
      this.searchTimeOut()
    },
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        // your code
        this.currentPage = 1
        this.get_data()
      }, 500)
    },
  },
}
</script>

<style lang="scss">
.b-table-selectable{
  .feather{
    font-size: 1.3rem;
  }
}

</style>
